var map = {
	"./blue_background_waves.png": 7862,
	"./cream.png": 1633,
	"./front_water.png": 3432,
	"./mountain.png": 2438,
	"./navy_purple.png": 1247,
	"./particles.png": 2625,
	"./sea_monster.png": 2277,
	"./ship.png": 2611,
	"./side_waves.png": 5779,
	"./title.png": 7129
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9148;